if (!customElements.get('bbn-related')) {
  /* You May Also Like: +/- adds or removes one bag of the size chosen at the top
     of the product page (client memo). Counts mirror the live cart. */
  class BbnRelated extends HTMLElement {
    connectedCallback() {
      this.onSize = (event) => {
        const detail = event.detail || {};
        if (String(detail.productId) !== this.dataset.productId) return;
        this.dataset.size = detail.sizeLabel;
        this.sizeLabel = detail.sizeLabel;
        if (this.cards && this.cards.length) this.render();
      };
      document.addEventListener('bbn:size-change', this.onSize);

      if (this.dataset.recsUrl) this.loadRecommendations();
      else this.init();
    }

    /* No products/collection picked: cards come from Search & Discovery via the
       product recommendations endpoint, which renders this same section. */
    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.recsUrl);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('.related-grid');
        if (!grid || !grid.querySelector('.related-card')) return;
        this.querySelector('.related-grid').innerHTML = grid.innerHTML;
        this.hidden = false;
        this.init();
      } catch (error) {
        console.error(error);
      }
    }

    init() {
      this.cards = Array.from(this.querySelectorAll('.related-card')).map((el) => {
        let variants = {};
        try {
          variants = JSON.parse(el.dataset.variants || '{}');
        } catch (error) {
          variants = {};
        }
        return { el, variants, output: el.querySelector('output'), dec: el.querySelector('[data-step="-1"]') };
      });
      if (!this.cards.length) return;

      this.sizeLabel = this.dataset.size || Object.keys(this.cards[0].variants)[0];

      this.onCart = (event) => {
        this.cart = event.detail && event.detail.cart;
        this.render();
      };
      document.addEventListener('bbn:cart:updated', this.onCart);
      this.addEventListener('click', this.onClick.bind(this));

      const load = () => {
        if (!window.BBNCart) return;
        window.BBNCart.getCart().then((cart) => {
          this.cart = cart;
          this.render();
        });
      };
      if (window.BBNCart) load();
      else window.addEventListener('DOMContentLoaded', load, { once: true });
    }

    disconnectedCallback() {
      document.removeEventListener('bbn:size-change', this.onSize);
      if (this.onCart) document.removeEventListener('bbn:cart:updated', this.onCart);
    }

    variantFor(card) {
      return card.variants[this.sizeLabel] || null;
    }

    render() {
      this.querySelectorAll('[data-related-size]').forEach((el) => {
        el.textContent = `(${this.sizeLabel})`;
      });
      this.cards.forEach((card) => {
        const id = this.variantFor(card);
        const qty = id && this.cart && window.BBNCart ? window.BBNCart.qtyFor(this.cart, id) : 0;
        card.output.textContent = qty;
        card.dec.disabled = qty <= 0;
        card.el.querySelectorAll('.related-card__step').forEach((btn) => {
          if (btn.dataset.step === '1') btn.disabled = !id;
        });
      });
    }

    async onClick(event) {
      const btn = event.target.closest('.related-card__step');
      if (!btn || btn.disabled || !window.BBNCart) return;
      const card = this.cards.find((c) => c.el.contains(btn));
      const id = card && this.variantFor(card);
      if (!id) return;

      const current = this.cart ? window.BBNCart.qtyFor(this.cart, id) : 0;
      const next = Math.max(0, current + Number(btn.dataset.step));
      card.el.classList.add('is-busy');
      try {
        this.cart = await window.BBNCart.change(id, next, 'bbn-related');
        this.render();
      } catch (error) {
        window.BBNCart.flash(error.message, true);
      } finally {
        card.el.classList.remove('is-busy');
      }
    }
  }

  customElements.define('bbn-related', BbnRelated);
}
